<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="处理状态">
                <a-select v-model="listQuery.processStatus">
                  <a-select-option :value="1">待处理</a-select-option>
                  <a-select-option :value="2">已处理</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <a-table
        :loading="loading"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false">
        <span slot="processStatus" slot-scope="text, record">
          {{ record.processStatus === 1 ? '待处理' : '已处理' }}
        </span>
        <span slot="type" slot-scope="text, record">
          {{ record.type | typeFilter }}
        </span>
        <span slot="content" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">
              {{ record.content }}
            </template>
            {{ record.content.slice(0, 15) }}{{ record.content.length > 15 ? '...' : '' }}
          </a-tooltip>
        </span>
        <span slot="processResult" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">
              {{ record.processResult }}
            </template>
            {{ record.processResult.slice(0, 15) }}{{ record.processResult.length > 15 ? '...' : '' }}
          </a-tooltip>
        </span>
        <span slot="imgUrls" slot-scope="text, record">
          <template v-if="record.imgUrls">
            <viewer :images="JSON.parse(record.imgUrls)">
              <img style="width: 50px; height: 50px; cursor: pointer; margin: 0 10px 10px 0;" v-for="(item, index) in JSON.parse(record.imgUrls)" :key="index" :src="item" alt="">
            </viewer>
          </template>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleEdit(record.id)" v-if="record.processStatus === 1">
            <a-icon type="edit" />处理
          </a>
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-pageSize-changer
        show-quick-jumper
        :pageNum="listQuery.pageNum"
        :total="total"
        :page-pageSize="listQuery.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <a-modal
      title="回复"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="visible = false"
    >
      <a-input v-model="dataForm.processResult" />
    </a-modal>
  </page-header-wrapper>
</template>
<script>
import { qryFeedback, addFeedback } from '@/api/com/feedback'
export default {
  name: '',
  data () {
    return {
      loading: false,
      columns: [
        { title: '反馈时间', dataIndex: 'createTime', align: 'center', width: '150px' },
        { title: '反馈类型', dataIndex: 'type', scopedSlots: { customRender: 'type' }, align: 'center', width: '150px' },
        { title: '反馈内容', dataIndex: 'content', scopedSlots: { customRender: 'content' }, align: 'center' },
        { title: '反馈图片', dataIndex: 'imgUrls', scopedSlots: { customRender: 'imgUrls' }, align: 'center', width: '250px' },
        { title: '处理状态', dataIndex: 'processStatus', scopedSlots: { customRender: 'processStatus' }, align: 'center', width: '150px' },
        { title: '处理结果', dataIndex: 'processResult', scopedSlots: { customRender: 'processResult' }, align: 'center' },
        { title: '操作', dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, align: 'center', width: '150px' }
      ],
      listQuery: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      list: [],
      visible: false,
      confirmLoading: false,
      dataForm: {}
    }
  },
  filters: {
    typeFilter(val) {
      switch (val) {
        case 1:
          return '下载/加载问题'
        case 2:
          return '设备体验问题'
        case 3:
          return '章节/图片问题'
        case 4:
          return 'APP体验问题'
        case 5:
          return '卡顿/不流畅'
        case 6:
          return '其他'
        default:
          break
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList() {
      qryFeedback(this.listQuery).then(res => {
        this.list = res.data.records
        this.total = Number(res.data.total)
      })
    },
    // 查询
    handleQuery() {
      this.listQuery.pageNum = 1
      this.getList()
    },
    handleOk() {
      addFeedback(this.dataForm).then(res => {
        this.visible = false
        this.getList()
      })
    },
    handleEdit(id) {
      this.dataForm = {
        id: id,
        processStatus: 2,
        processResult: '您的反馈已收到，我们会尽快处理'
      }
      this.visible = true
    },
    resetQuery() {
      this.listQuery = {
        pageNum: 1,
        pageSize: 10
      }
      this.getList()
    },
    onShowSizeChange (pageNum, pageSize) {
      this.listQuery.pageSize = pageSize
      this.getList()
    },
    changeSize (pageNum, pageSize) {
      this.listQuery.pageNum = pageNum
      this.listQuery.pageSize = pageSize
      this.getList()
    }
  }
}
</script>

<style lang='scss' scoped>

</style>
